module.exports = __webpack_public_path__ + "static/img/logo2.46684ac9.png";